let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [
    {
        label: 'url',
        props: 'url',
        minWidth: 300,
    },
    {
        label: 'operatorId',
        props: 'operatorId',
        minWidth: 200,
        tooltip:true,
    },
    {
        label: '桩号',
        props: 'connectorId',
        minWidth: 200,
    },
    {
        label: '序列号',
        props: 'startChargeSeq',
        minWidth: 300,
    },
    {
        label: '开始时间',
        props: 'startTime',
        minWidth: 300,
    },
    {
        label: '结束时间',
        props: 'endTime',
        minWidth: 300,
    },
    {
        label: '总费用',
        props: 'totalMoney',
        minWidth: 300,
    },
    {
        label: '电费',
        //props: 'pileTypeCode',
        minWidth: 300,
        formatter: function formatter(row, column, cellValue, index) {
            // 做判断
            if (row.operatorId == '425010765' && row.pushTypeCode == '05') {
                return row.totalElecMoney;
            }
            else if(row.operatorId == '425010765' && row.pushTypeCode == '02'){
                return row.elecMoney
            }else{
                return ''
            }
        }
    },
    {
        label: '服务费',
        //props: 'pileTypeCode',
        minWidth: 300,
        formatter: function formatter(row, column, cellValue, index) {
            // 做判断
            if (row.operatorId == '425010765' && row.pushTypeCode == '05') {
                return row.totalServiceMoney;
            }
            else if(row.operatorId == '425010765' && row.pushTypeCode == '02'){
                return row.seviceMoney
            }else{
                return ''
            }
        }
    },
    {
        label: '订单号',
        //props: 'pileTypeCode',
        minWidth: 300,
        formatter: function formatter(row, column, cellValue, index) {
            // 做判断
            if (row.operatorId == '425010765' && row.pushTypeCode == '02') {
                return row.orderId;
            }else{
                return ''
            }
        }
    },
    {
        label: '推送参数',
        props: 'pushData',
        minWidth: 200,
    },
    {
        label: '推送参数(加密)',
        props: 'requestJson',
        minWidth: 200,
    },
    {
        label: '返回参数',
        props: 'backData',
        minWidth: 200,
    },
    {
        label: '返回参数(加密)',
        props: 'backDataAes',
        minWidth: 200,
    },
    {
        label: '推送类型',
        props: 'pushTypeCode',
        minWidth: 200,
    },
    {
        label: '推送类型',
        props: 'pushTypeName',
        minWidth: 200,
    },
    {
        label: '时间',
        props: 'createdWhen',
        minWidth: 200,
    },
];

// // 面包屑
pageConfig.listBreadCrumb = [{
    type: 'title',
    name: '首页',
},
{
    type: 'title',
    name: '系统管理'
},
{
    type: 'title',
    name: '推送日志'
}];

// 列表-表格属性
pageConfig.tableConfig = {
    showSelection: true,
    showIndex: true,
};

// 列表-分页参数
pageConfig.pagination = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100],
}
// 列表-编辑操作
// pageConfig.tableEditObj = {
//     editKey: 'userId',
//     editRouter: 'userManageDetail',
// };

// 路由
pageConfig.listRouter = 'push_log_list';

// 详情的面包屑
// pageConfig.detailBreadCrumb = [{
//     type: 'title',
//     name: '首页',
// },
// {
//     type: 'router',
//     name: '用户管理',
//     router: 'user_list'
// },
// {
//     type: 'title',
//     name: '详情',
// }];

pageConfig.formRules = {
};



export default pageConfig;